import React from 'react'
import './Menu.css'
import { Link, useLocation } from "react-router-dom";

function Menu() {

  const location = useLocation()
  const menu = [
      {"name": "Plantillas", "url": "/", "paths": ["/", "/team", "/player"]},
      {"name": "Jugadores", "url": "/searcher", "paths": ["/searcher"]},
      {"name": "Datos", "url": "/stats", "paths": ["/stats"]},
      {"name": "Pretemporada", "url": "/preseason", "paths": ["/preseason"]},
  ]

  const getClassName = (item) => {
    if (item.paths.includes(location.pathname)) {
      return "item active"
    }
    return "item"
  }
  return (
    <div className="menu">
      {menu.map((item, index) => (
            <div className={getClassName(item)} key={index}>
              <Link to={item.url}>  
                <div>{item.name}</div>
                </Link>
            </div>
          )
        )
      } 
    </div>
  )
}

export default Menu